<template>
<row-card @click="onCardClicked" :imageUrl="imageUrl" :leftTitle="name"
:leftSubtitle="location" :rightTitle="company" :rightSubtitle="period"
:class="experienceClass">
<template slot="leftSubtitle" v-if="!experience">
<span>
  <a @click.prevent="addClicked">{{this.$t('profile.addYourExperience')}}</a> {{this.$t('profile.toYourProfile')}}
</span>
</template>
</row-card>
</template>

<script>
import BlankImage from '@/assets/empty-state-icon@2x.png'
import RowCard from '@/components/general/row-card'
import moment from 'moment'

export default {
  components: {
    RowCard
  },
  props: {
    experience: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    experienceClass () {
      if (!this.experience) {
        return ['unclickable']
      } else {
        return []
      }
    },
    name () {
      if (this.experience) {
        return this.experience.role
      } else {
        return this.$t('profile.experienceName')
      }
    },
    location () {
      if (this.experience) {
        return this.experience.location
      } else {
        return null
      }
    },
    company () {
      if (this.experience) { return this.experience.companyName }
      return null
    },
    imageUrl () {
      if (this.experience && this.experience.companyImageUrl) {
        return this.experience.companyImageUrl
      } else if (this.experience) {
        return `/api/identicons/${this.experience.id}`
      } else {
        return BlankImage
      }
    },
    period () {
      if (!this.experience) { return null }
      const from = this.experience.fromDate
      const to = this.experience.untilDate
      const format = 'MMM YYYY'
      const start = moment.utc(from).format(format)

      const end = this.experience.isCurrentPosition
        ? 'Present' : moment.utc(to).format(format)
      return `${start} - ${end}`
    }
  },
  methods: {
    addClicked () {
      this.$emit('add')
    },
    onCardClicked () {
      this.$emit('edit')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.experience-card:not(:last-child) {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.experience-card:not(:first-child) {
  border-top: 0;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.card {
  cursor: pointer;
}

.experience-card:hover {
  background-color: $hover-background;
}

.unclickable:hover {
  cursor: unset !important;
}

</style>



// WEBPACK FOOTER //
// src/components/profile/experience-row-card.vue